import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';

import Home from './Home';
import Login from './Login';
import LoginWithToken from "./LoginWithToken";

class App extends Component {
  render() {
    const { token } = this.props;
    return (
      <div>
        <ReduxToastr />
        <BrowserRouter>
          <Switch>
            <Route
              path='/iotservice'
              component={ () =>
                  window.location =
                    `http://iot.rmc.ai/login-with-token?id_token=${token["IdToken"]}&refresh_token=${token["RefreshToken"]}&access_token=${token["AccessToken"]}`
              }
            />
            <Route path="/login-with-token" name="Login With Tokens" component={LoginWithToken} />
            {
              token ? <Route path="/" name="Home" component={Home} /> : <Route path="/" name="Login Page" component={Login} />
            }
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

function mapStateToProps({ token }) {
  return {
    token
  };
}

export default connect(mapStateToProps, null)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js